import { useEffect, useRef } from 'react'

// Calls callback(true) when the element enters the viewport (10% visible) and
// callback(false) when it leaves. Returns the ref to attach.
const useIntersectionObserver = (callback) => {
  const ref = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            callback(true)
          } else {
            callback(false)
          }
        })
      },
      { threshold: 0.1 },
    )
    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current)
      }
    }
  }, [callback])

  return ref
}

export default useIntersectionObserver
